module.exports = __webpack_public_path__ + "3a5952e8e3fce4830306a8034641b652.jpg";